export default class Installment {
    quantity            = null;
    installmentAmount   = null;
    totalAmount         = null;
    interestFree        = null;

    constructor(){ }
}


    